<template>
  <div id="app">
    <img class="logo" alt="Vue logo" src="https://musiquedepot.ca/assets/logomdmobile.png">
    <number />
  </div>
</template>

<script>
import number from './components/HelloWorld.vue'

export default {
  name: 'App',
  components: {
    number
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  padding-top: 60px;
  background-color: black;
}
.logo{
  max-height: 10vh;
}
html {
  background-color: black;
}
</style>
